import { DO_NOT_USE_FaWrapper } from '../../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { StyledIconButton } from './styled.js';
import { jsx } from 'react/jsx-runtime';

function ResetButton(props) {
  var show = props.show,
    label = props.label,
    onClick = props.onClick;
  if (!show) {
    return null;
  }
  return /*#__PURE__*/jsx(StyledIconButton, {
    type: "button",
    appearance: "ghost",
    size: "small",
    "aria-label": label,
    onClick: onClick,
    children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
      icon: faXmark,
      $color: "text.100"
    })
  });
}

export { ResetButton };
